import { useState, useEffect } from 'react';
import api from '../../utils/api';   // Axios instance with baseURL: http://localhost:8080

export default function AdminShipping() {
  const [rates, setRates] = useState([]);
  const [location, setLocation] = useState('');
  const [cost, setCost] = useState('');
  const [editingId, setEditingId] = useState(null);
  const [editLocation, setEditLocation] = useState('');
  const [editCost, setEditCost] = useState('');

  const fetchRates = () => {
    api.get('/api/admin/shipping')          // full URL: http://localhost:8080/api/admin/shipping
      .then(res => setRates(res.data))
      .catch(() => {});
  };

  useEffect(() => {
    fetchRates();
  }, []);

  const handleAdd = async (e) => {
    e.preventDefault();
    if (!location.trim() || !cost.trim()) return;
    try {
      await api.post('/api/admin/shipping', {
        location,
        cost: parseFloat(cost),
      });
      setLocation('');
      setCost('');
      fetchRates();
    } catch (err) {
      alert('Failed to add shipping rate');
    }
  };

  const startEdit = (rate) => {
    setEditingId(rate.id);
    setEditLocation(rate.location);
    setEditCost(rate.cost.toString());
  };

  const cancelEdit = () => {
    setEditingId(null);
  };

  const handleUpdate = async (id) => {
    try {
      await api.put(`/api/admin/shipping/${id}`, {
        location: editLocation,
        cost: parseFloat(editCost),
      });
      setEditingId(null);
      fetchRates();
    } catch (err) {
      alert('Failed to update shipping rate');
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this rate?')) return;
    try {
      await api.delete(`/api/admin/shipping/${id}`);
      fetchRates();
    } catch (err) {
      alert('Failed to delete');
    }
  };

  return (
    <div>
      <h2 className="text-xl font-bold mb-4">Shipping Rates</h2>

      {/* Add form */}
      <form onSubmit={handleAdd} className="mb-6 border p-4 rounded space-y-3">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
          <input
            type="text"
            placeholder="Location (e.g. Lagos)"
            className="border p-2 rounded"
            value={location}
            onChange={e => setLocation(e.target.value)}
            required
          />
          <input
            type="number"
            step="0.01"
            placeholder="Cost (₦)"
            className="border p-2 rounded"
            value={cost}
            onChange={e => setCost(e.target.value)}
            required
          />
          <button type="submit" className="bg-black text-white px-4 py-2 rounded">
            Add Rate
          </button>
        </div>
      </form>

      {/* Rates list */}
      <div className="space-y-2">
        {rates.map(rate => (
          <div key={rate.id} className="border p-3 rounded flex items-center justify-between">
            {editingId === rate.id ? (
              <div className="flex-1 flex items-center gap-2">
                <input
                  type="text"
                  value={editLocation}
                  onChange={e => setEditLocation(e.target.value)}
                  className="border p-1 rounded flex-1"
                />
                <input
                  type="number"
                  step="0.01"
                  value={editCost}
                  onChange={e => setEditCost(e.target.value)}
                  className="border p-1 rounded w-32"
                />
                <button
                  onClick={() => handleUpdate(rate.id)}
                  className="bg-green-600 text-white px-3 py-1 rounded text-sm"
                >
                  Save
                </button>
                <button
                  onClick={cancelEdit}
                  className="bg-gray-300 px-3 py-1 rounded text-sm"
                >
                  Cancel
                </button>
              </div>
            ) : (
              <>
                <span>
                  {rate.location} – ₦{rate.cost.toFixed(2)}
                </span>
                <div className="flex gap-2">
                  <button
                    onClick={() => startEdit(rate)}
                    className="text-blue-500 hover:underline text-sm"
                  >
                    Edit
                  </button>
                  <button
                    onClick={() => handleDelete(rate.id)}
                    className="text-red-500 hover:underline text-sm"
                  >
                    Delete
                  </button>
                </div>
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}